import React from 'react'

const Either = ({ condition, thisOne, orThatOne }) => <>{condition === true ? thisOne : orThatOne}</>

export default Either
